module.exports = __webpack_public_path__ + "static/img/amp2.b394d8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/amp2.png
// module id = 289
// module chunks = 0